(() => {
  "use strict";
  var t = {
    n: (r) => {
      var a = r && r.__esModule ? () => r.default : () => r;
      return t.d(a, { a }), a;
    },
    d: (r, a) => {
      for (var e in a)
        t.o(a, e) &&
          !t.o(r, e) &&
          Object.defineProperty(r, e, { enumerable: !0, get: a[e] });
    },
    o: (t, r) => Object.prototype.hasOwnProperty.call(t, r),
  };
  const r = jQuery;
  var a = t.n(r),
    e = function (t) {
      var r = JSON.parse(t.attr("data-product-variants")),
        e = JSON.parse(t.attr("data-product-tags")) || [],
        n = t.attr("data-product-type") || "",
        i = t.attr("data-product-id") || "",
        d =
          "null" === t.attr("data-collection")
            ? []
            : JSON.parse(t.attr("data-collection")),
        o = JSON.parse(t.attr("data-product-collection-titles")) || [],
        l = t.attr("data-initial-variant") || [],
        c = t.attr("data-sold-out") || "",
        u = t.attr("data-back-order") || "",
        p = t.attr("data-pre-order") || "",
        s = r.reduce(function (t, r) {
          return (t[r.id] = r.inventory_policy), t;
        }, {}),
        v = r.reduce(function (t, r) {
          return (t[r.id] = r.inventory_quantity), t;
        }, {}),
        f = document.querySelector(".product-card-list2__".concat(i)),
        y = f.querySelector("[data-dropdown-id='productSelect-dropdown']"),
        h = f.querySelector("#tag-container"),
        m = function (t) {
          var i,
            l,
            f = t.selectedVariantId,
            m = t.initialized,
            S = (function (t) {
              var r = t.productVariants,
                a = t.selectedVariantId,
                e = t.initialized,
                n = r.find(function (t) {
                  return t.id === parseInt(a, 10);
                });
              if (!e && !1 === n.available) {
                var i = r.find(function (t) {
                  return !0 === t.available;
                });
                if (i) return i;
              }
              return n;
            })({ productVariants: r, selectedVariantId: f, initialized: m });
          m || (a()(y).val() !== S.id && a()(y).val(S.id));
          var I,
            _,
            b = v[S.id],
            O = s[S.id];
          !1 === S.available
            ? ((I = c), (_ = "outstock-overlay"))
            : (null != d &&
                null !== (i = d.title) &&
                void 0 !== i &&
                i.includes("pre-order")) ||
              (null != d &&
                null !== (l = d.title) &&
                void 0 !== l &&
                l.includes("preorder")) ||
              (null != o &&
                o.some(function (t) {
                  return t.includes("pre-order");
                })) ||
              (null != o &&
                o.some(function (t) {
                  return t.includes("preorder");
                })) ||
              (null != e && e.includes("preorder"))
            ? ((I = p), (_ = "preorder-overlay"))
            : "Event Ticket" !== n && b <= 0 && "continue" === O
            ? ((I = u), (_ = "backorder-overlay"))
            : (_ = "hidden"),
            (h.innerText = I),
            (h.className = _),
            a()(y).attr("last", S.id);
          var V = a()(y)
            .parent()
            .parent()
            .find('input[name="prduct-variant"]')
            .first();
          V && V.attr("value", S.id);
          var g = a()(y)
            .parent()
            .parent()
            .find("span.product-price__price.qv-regularprice");
          if (g) {
            var j = Shopify.formatMoney(S.price, Shopify.money_format);
            g.text(j);
          }
          var q,
            w,
            z,
            N =
              ((q = {
                url: a()(y).parent().parent().find("a").first().attr("href"),
                variantId: S.id,
              }),
              (w = q.url),
              (z = q.variantId),
              w && z
                ? w
                    .split("&")
                    .map(function (t) {
                      return t.startsWith("variant=")
                        ? "variant=".concat(z)
                        : t;
                    })
                    .join("&")
                : null);
          N &&
            (a()(y).parent().parent().find("a").first().attr("href", N),
            a()(y)
              .parent()
              .parent()
              .parent()
              .find("a")
              .first()
              .attr("href", N));
        };
      y.addEventListener("change", function (t) {
        m({ selectedVariantId: parseInt(t.target.value, 10), initialized: !0 });
      }),
        m({ selectedVariantId: l, initialized: !1 });
    };
  a()(window).load(function () {
    a()('div[id^="productCardList2-js-"]').each(function (t, r) {
      e(a()(r));
    });
  });
})();
